export default __webpack_public_path__ + "static/media/dev-united-logo.837b6858.svg";